import { i18n } from '@/main'
import store from '@/store'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import { Notification } from 'element-ui'
import has from 'lodash.has'
import Vue from 'vue'

// Init sentry
if (process.env.VUE_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [new Integrations.Vue({ Vue, attachProps: true })],
    whitelistUrls: [process.env.VUE_APP_SPA_URL],
    ignoreErrors: [
    'TypeError: Failed to fetch',
    'TypeError: NetworkError when attempting to fetch resource.',
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications',
    '/^null is not an object.*(evaluating.*)$/'
  ],
  })
}

export const errorHandler = error => {
  if (error && error.status && error.status === 404) {
    // api without errors :)
    return
  }
  // Logout in case of 401
  if (error && error.status && error.status === 401) {
    if (store.getters['auth/logged_in']) {
      store.dispatch('auth/logout')

      Notification({
        type: 'error',
        title: i18n.t('base.errors.notificationTitle'),
        message: 'Session expirée, veuillez vous reconnecter.'
      })
    }
  }

  if (has(error, 'data.errors')) {
    Notification({
      type: 'error',
      title: i18n.t('base.errors.notificationTitle'),
      message:
        typeof error.data.errors === 'string'
          ? error.data.errors
          : error.data.errors
              .map(i => {
                if (typeof i === 'string') {
                  return i
                } else {
                  return i.message
                }
              })
              .join('<br/><br/>'),
      dangerouslyUseHTMLString: true
    })
  } else if (error && error.status && error.status === 401) {
    // Logout in case of 401
    store.dispatch('auth/logout')

    Notification({
      type: 'error',
      title: i18n.t('base.errors.notificationTitle'),
      message: 'Session expirée, veuillez vous reconnecter.'
    })
  } else {
    // In case an error is thrown without `response.data.errors`
    console.warn('error', error)
    // TODO: handle other cases.
    Notification({
      type: 'error',
      title: i18n.t('base.errors.notificationTitle'),
      message: i18n.t('base.errors.defaultMessage')
    })
  }
}

// Overriding default `errorHandler`
Vue.config.errorHandler = errorHandler
